import React,{forwardRef} from 'react';
import logo from '../../assets/imagenes/logo.png';
import firebase from '../../utils/firebase';
import { useSelector, useDispatch } from 'react-redux'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import ThemeConstext, {themes} from '../../components/Context';
import { useState } from 'react';
import { getVendedor, getClientes, getConfiguracion, getTickets } from '../../components/API'
import { Redirect } from "react-router";
import Snackbar from '@mui/material/Snackbar'; //actualizacion nodejs
import MuiAlert from '@mui/material/Alert'; //actualizacion nodejs
import types from '../../actions/types'

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Login() {
  const [theme, setTheme] = useState(themes.light);
  const [formData, setFormData] = useState(defaultValue());
  const [mensaje, setMensaje] = useState('');
  const [respuesta, setRespuesta] = useState(false);
  const [iniciando, setIniciando] = useState(false);
  const dispatch  = useDispatch();
  const {syncs} =  useSelector((state)=>{ return state });
  var user = syncs.vendedor?syncs.vendedor:null;

  const handleLogin  = () =>{
    setIniciando(true);
    let errors = {};
    if (!formData.email || !formData.password) {
      if (!formData.email) errors.email = true;
      if (!formData.password) errors.password = true;
    } else {
      firebase.auth().signInWithEmailAndPassword(formData.email + "@agristar.com.mx", formData.password).then(()=>{
          let users = firebase.auth().currentUser;
          if (users){
            setAll(users);
          }
          })
        .catch((error) => {
          setMensaje(types.LOGIN_FAIL);
          setRespuesta(true);
          setIniciando(false);
        });
    }
  };

  async function setAll(user){
    dispatch({type:"FETCHING_START"})
    let numero = await getVendedor(user.email);
    if( numero.VKBUR ){
      dispatch({type:"VENDEDOR_LOGIN", payload: { login:true, email: user.email, uid: user.uid, 
      numero_vendedor: numero.KUNNR, vendedor_nombre: numero.NAME1, VKBUR: numero.VKBUR, VKORG: numero.VKORG} })
      let configuracion = await getConfiguracion();
      dispatch({type:"CONFIGURACION_FETCHING", payload: { configuracion } })
      let clientes = await getClientes(numero.VKBUR);
      //console.log(clientes)
      dispatch({type:"CLIENTES_FETCHING", payload: { clientes } })
      let tickets = await getTickets(numero.KUNNR);
      dispatch({type:"TICKETS_FETCHING", payload: { tickets } })
      dispatch({type:"FETCHING_END"})
      setTimeout(function() { 
        dispatch({type:"CLIENTES_FETCHING", payload: { clientes } })
      }, 2000); 
      setIniciando(false);
    }else{
      setMensaje(types.FETCH_VENDEDOR_FAIL)
      setRespuesta(true)
      setIniciando(false);
      await firebase.auth().signOut();
    }
    // setRespuesta(false);
    // history.push("/");
    // return <Redirect to="/" />
  }

  const onChange = (e, type) => {
    setFormData({...formData, [type]: e.target.value});
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setRespuesta(false);
  };

  return ( 
  <ThemeConstext.Provider value={theme}>
    <div className="grid-container" style={theme}>
      <main>
        <div style={{justifyContent: "center", alignItems: "center", display: "flex"}}>
          <img className="App-logo" src={logo} alt="logo" height="120" />
        </div>
        <div style={{justifyContent: "center", alignItems: "center", display: "flex"}}>
          {user? 
          <>
            <Redirect to="/" />
          </>:
          <Form onSubmit={e => e.preventDefault() && false}>
            <Form.Group controlId="formBasicEmail">
              <Form.Control 
              type="text" 
              placeholder="Usuario" 
              style={styles.input}  
              required
              autoComplete="false" 
              onChange={(e) => onChange(e, 'email')}/>
            </Form.Group>
            <Form.Group controlId="formBasicPassword">
              <Form.Control 
              type="password" 
              placeholder="Contraseña" 
              style={styles.input} 
              required
              onChange={(e) => onChange(e, 'password')}/>
            </Form.Group>
            <Button variant="primary" type="submit"  disabled={iniciando} style={styles.botones} onClick={handleLogin}> Iniciar Sesión </Button>
            <span style={{fontSize: 10}}>Versión 1.7.0</span>
          </Form>
          }
          <Snackbar open={respuesta} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <Alert onClose={handleClose} severity="error">
              {mensaje}
            </Alert>
          </Snackbar>
        </div> 
      </main>
    </div>
  </ThemeConstext.Provider>      
  );
}

function defaultValue() {
  return {
    email: '',
    password: '',
  };
}

const styles = {
  input: {
    height: 60,
    color: '#fff',
    width: '100%',
    backgroundColor: '#3f51b5',
    paddingHorizontal: 20,
    borderRadius: 50,
    fontSize: 18,
    borderWidth: 1,
    borderColor: '#3f51b5',
    marginTop: 25,
    alignSelf: "center"
  },
  btnText: {
    color: '#fff',
    fontSize: 18,
  },
  register: {
    flex: 1,
    justifyContent: 'flex-end',
    marginBottom: 10,
  },
  error: {
    borderColor: '#940c0c',
  },
  botones:{
    marginTop:'20px', 
    marginBottom:'10px',
    alignItems:"center", 
    width:"100%", 
    alignSelf:"center", 
    elevation:.5, 
    alignContent:"center",
    backgroundColor: '#3f51b5',

  },
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center",
    width: "100%",
    height: "100%"
  },
};
export default Login;
